export default {
  buttons: {
    cancel: "مسح  ",
    dismiss: "اغلاق",
    add_waypoint: "أضف وجهة"
  },
  distance: {
    value: "{distance, number, distance} {unit}",
    unit: {
      miles: "ميل"
    }
  },
  search: {
    title: "بحث ",
    placeholder: "أدخل موقع",
    enter_location: "أدخل موقع",
    help: {
      inactive: "بحث "
    }
  },
  filters: {
    title: "مرشحات ",
    amenities: {
      title: "خدمات ووسائل الراحة"
    },
    fuels: {
      title: "نوع الوقود"
    }
  },
  directions: {
    title: "مخطط الطريق",
    placeholder: {
      destination: "أدخل موقع",
      waypoint: "أدخل موقع"
    },
    route: {
      title: "خيارات المسار",
      avoid_tolls: "تجنب الطرق ذات الرسوم",
      avoid_highways: "تجنب الشوارع السريعة",
      title_corridor: "المسافة من الطريق الى محطات الخدمة (ميل)"
    },
    travel_time: `\
{weeks, plural, =0 {} =1 {# wk} other {# wks}}
{days, plural, =0 {} =1 {# يوم } other {# ايام }}
{hours, plural, =0 {} =1 {# hr} other {# hrs}}
{minutes, plural, =0 {} =1 {# دقيقة } other {# دقائق}}\
`,
    button: "بحث "
  },
  locations: {
    title: "المواقع",
    distance: "{distance, number, distance} {unit}",
    distance_from: "{distance, number, distance} {unit} من  {place}"
  },
  info_window: {
    title: "تفاصيل الموقع",
    services: "خدمات ووسائل الراحة",
    nearby: "بالقرب من",
    opening_hours: {
      title: "ساعات الافتتاح والإغلاق",
      period: "{start, time, short} – {end, time, short}"
    },
    fuel_prices: {
      price: "{price, number, fuelPrice}",
      last_updated_on: "أخر تحديث",
      timestamp: "{timestamp, date, dateFormat}"
    }
  },
  itinerary: {
    title: "مخطط الطريق"
  },
  fuels: {
    low_octane_gasoline: "وقود شل – بنزين 91",
    midgrade_gasoline: "وقود شل – بنزين 95",
    shell_regular_diesel: "وقود شل - ديزل ",
    premium_gasoline: "Shell V-Power"
  },
  amenities: {
    air_and_water: "هواء",
    atm: "صراف آلي",
    austrian_highway_sticker: "ملصق الطريق الاسترالي",
    bank_note_acceptor: "ماكينة ايداع",
    bottled_gas: "استبدال أسطوانات بروبين BBQ",
    cafe: "كافتيريا",
    carwash: "غسيل السيارات",
    clubsmart_card: "نادي البطاقة الذكية",
    costa_express: "كوستا إكسبرس",
    credit_card_american_express: "بطاقة الائتمان- أمريكان إكسبرس",
    credit_card_diners_club: "بطاقة الإئتمان- داينرز كلاب",
    credit_card_mastercard: "بطاقة الائتمان- ماستركارد",
    credit_card_visa: "بطاقة الائتمان- فيزا",
    credit_card: "بطاقة الائتمان",
    czech_highway_sticker: "ملصق الطريق الشيكي",
    euroshell_card: "يورو شل / بطاقة شل ",
    fleet_card_dkv: "بطاقة الأسطول -قرية دبي للمعرفة",
    fleet_card_eni: "بطاقة اسطول- Eni",
    fleet_card_esso: "بطاقة أسطول- ESSO",
    fleet_card_general: "بطاقة الأسطول",
    fleet_card_uta: "بطاقة الأسطول- UTA",
    food_offerings: "الطعام المقدم ",
    full_service: "خدمة كاملة / حضور الخدمة",
    guarded_car_park: "مواقف مع حرس أمن",
    hgv_lane: "شاحنات ودية",
    high_speed_diesel_pump: "ديزل عالية السرعة",
    hot_food: "وجبات ساخنة",
    hungarian_highway_sticker: "ملصق الطريق الهنجاري",
    ido_ticket: "أيدو للتذاكر",
    maut_terminal: "بوابة الماوت",
    parking_lanes: "مواقف السيارات",
    partner_loyalty_accepted: "ولاء الشريك مقبول",
    pay_at_pump: "الدفع عند المضخة",
    quick_lubes: "لوب السريع",
    restaurant: "مطعم",
    self_service: "خدمة شخصية",
    service_bay: "ساحة الخدمة",
    shell_card: "يورو شل / بطاقة شل ",
    shell_club_smart_extra_card: "نادي البطاقة الذكية الذهبية",
    shop: "تسوق",
    shower: "دورات للاستحمام",
    slovak_highway_sticker: "ملصق الطريق السلوفاكي",
    snack_food: "الوجبات الخفيفة والسريعة",
    standard_toilet: "دورات مياه",
    supermarket_fuel_discount: "خصم للوقود",
    toilet: "دورات مياه",
    truck_parking: "مواقف الشاحنات",
    truckport: "الشاحنات فقط",
    twenty_four_hour: "24 ساعة",
    vacuum: "ألة تنظيف",
    vehicle_identity_system: "نظام تعريف السيارة",
    wifi: "واي فاي"
  },
  settings: {
    title: "اعدادات",
    tooltip: "اعدادات",
    distance_units: {
      title: "المسافة",
      km: "كيلومتر",
      miles: "ميل"
    },
    language: {
      title: "اللغة"
    }
  }
}
